module.exports = __webpack_public_path__ + "img/bin.8708cdaa.svg";